import React from 'react';

const version = process.env.REACT_APP_VERSION;

const PageFooter = () => (
  <footer className="page-footer">
    <div className="footer-version">
      v{version}
    </div>
  </footer>
);

export default PageFooter;
